import { Box } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";

import * as Styled from './shortInvoiceSummary.styles'
import { useState } from "react";
import { GetCalculatedInvoiceSummary } from "engine/baseApiClient";

export default function ShortInvoiceSummaryPanel({ invoice }) {  
  const [summary, setSummary] = useState({
    vat: []
  });  

  const doGetInvoiceSummaryAsync = async (payload) => {
    setSummary(await GetCalculatedInvoiceSummary(payload));
  };

  React.useEffect(() => {
    const payload = {
      items: invoice.items,
      currency: invoice.currency,
    };

    doGetInvoiceSummaryAsync(payload);
  }, [invoice.items]);

    return (
        <Box>
            <Stack direction="row" flexGrow={1} sx={{ mt: 3 }}>
                <Stack direction="column" flex={1}>
                    <Styled.Label width={150}>Suma netto:</Styled.Label>
                    <Styled.Label width={150}>Suma VAT:</Styled.Label>
                    <Styled.Title width={150}>Suma brutto:</Styled.Title>
                </Stack>
                <Stack direction="column" justifyContent="flex-start" alignItems="stretch" sx={{ ml:1, mr:2}}>
                    <Styled.Label>{summary.netTotal}</Styled.Label>
                    <Styled.Label>{summary.taxTotal}</Styled.Label>
                    <Styled.Title>{summary.grossTotal}</Styled.Title>
                </Stack>    
            </Stack>
        </Box>
    );
}